export enum CheckoutStep {
	RATE = 'rate',
	DATE = 'date',
	TIME = 'time',
	ADDON = 'addon',
	CHECKOUT = 'checkout',
}
